"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appPermissionSchema = exports.APP_PERMISSIONS = void 0;
const zod_1 = require("zod");
exports.APP_PERMISSIONS = [
    "customers:read",
    "customers:write",
    "jobs:read",
    "jobs:write",
    "appointments:read",
    "appointments:write",
    "estimates:read",
    "estimates:write",
    "invoices:read",
    "accounting:export",
    "payments:read",
    "leads:read",
    "leads:write",
    "leads:assign",
    "leads:convert",
    "leads:archive",
    "leads:ingest",
    "pipeline:manage",
    "inbox:read",
    "inbox:reply",
    "inbox:assign",
    "inbox:manage",
    "voice:read",
    "voice:call",
    "voice:manage",
    "voice:recordings:listen",
];
exports.appPermissionSchema = zod_1.z.enum(exports.APP_PERMISSIONS);
//# sourceMappingURL=permissions.js.map